

<p-drawer 
    header="&nbsp;"
    [(visible)]="visible" 
    [fullScreen]="true"
    (onHide)="handleOnHide()"
    >
    
    @if (roomData) {
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="room-data mb-3">
                        <div class="row">
                            <div class="col-10">
                                <h2 class="room-name">{{roomData.roomrates[0].room.pim?.name ?? roomData.roomrates[0].room.roomName}}</h2>
                            </div>
                            <div class="col-2">
                                @if (getCategoryName(roomData.roomrates[0].room)) {
                                    <div class="room-category-tag">{{getCategoryName(roomData.roomrates[0].room)}}</div>
                                }
                            </div>
                        </div>
                        <div class="room-description" [innerHTML]="roomData.roomrates[0].room.pim?.shortDescription"></div>
                    </div>
                </div>
            </div>
    
            <div class="row">
                @if (roomData.roomrates) {
                    @for (rate of roomData.roomrates; track $index) {
                        <div class="col-12 col-md-4 readmore-rate-col">
                            <div class="readmore-rate-container" [class.rate-highlight]="rate.rate.bookingCode || rate.rate.isLastMinute || rate.rate.isNonRef">
                                <app-availability-room-2-rate [rate]="rate" (onSelect)="selectRoomRate(rate)"></app-availability-room-2-rate>
                            </div>
                        </div>
                        
                    }
                    
                }
            </div>
    
        </div>
    
    }
    
</p-drawer>